<template>
  <div class="c-pc-title" :class="info ? info.className : ''" :id="info.id">
    <div class="title-name">
      {{ info.name ? info.name : "会议介绍" }}
    </div>
    <div class="title-tips">
      {{ info.enName }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    info: {}
  }
};
</script>

<style scoped></style>
